import * as React from 'react';
import { ButtonSecondary, createValidationErrors, ValidationProps } from 'ui';
import styles from './report-screen.scss';
import {  ComplexValue, FavouriteDefinition } from 'app/types-shared';
import { ScheduleDefinition, ScheduleFailedConstraints } from 'app/area/company-report/types-store';
import { ScheduleForm } from 'app/area/company-report/components/schedule-form';
import { SpinLoader } from 'app/components';
import get from 'lodash/get';

interface ScheduleReportProps {
  definition: FavouriteDefinition;
  showUpdate: boolean;
  onUpdateReport: () => void;
  deleteScheduleDefinition: () => void;
  initialOwners?: ComplexValue<number>[];
  scheduleDefinition: ScheduleDefinition;
  updateScheduleDefinition: (scheduleDefinition: ScheduleDefinition, validateSchedule: boolean) => void;
  translation: any;
  fetchingScheduleDefinition: boolean;
  locale: string;
  reportIsDisabled: boolean;
  createScheduleDefinition: () => void;
  scheduleFailedConstraints: ScheduleFailedConstraints;
  primaryOwnerLabel?: string;
  primaryOwnerInfoMessage?: string;
  primaryOwnerPlaceholder?: string;
}

// eslint:disable-next-line: max-func-body-length
export function ScheduleReport({
  deleteScheduleDefinition, locale, translation, scheduleDefinition, updateScheduleDefinition,
  fetchingScheduleDefinition, createScheduleDefinition, scheduleFailedConstraints,
  primaryOwnerLabel, primaryOwnerInfoMessage, primaryOwnerPlaceholder,
  initialOwners = []
}: ScheduleReportProps) {

  const { schedule_title, remove_schedule, add_schedule, failed_to_create_trigger } = translation;

  const onDeleteScheduleDefinition = () => (): void => {
    deleteScheduleDefinition();
  };

  const onAddScheduleDefinition = () => {
    createScheduleDefinition();
  };

  const getValidationErrors = (key: string): ValidationProps => {
    const value = get(scheduleFailedConstraints, key);
    return !!value && createValidationErrors([value as string]);
  };

  const scheduleDefinitionDetails = <>
  {scheduleDefinition?.scheduleDefinitionId && <div>
    <div className="row">
      <ButtonSecondary classNames={`${styles.linkButton} ${styles.deleteButton}`} onClick={onDeleteScheduleDefinition()}>
        <span>{remove_schedule}</span>
      </ButtonSecondary>
    </div>
    </div>}
    <div>
      <span>
        {scheduleDefinition && 
          <ScheduleForm 
            initialOwners={initialOwners}
            scheduleDefinition={scheduleDefinition}
            onUpdateScheduleDefinition={updateScheduleDefinition}
            locale={locale}
            translation={translation}
            getValidationErrors={getValidationErrors}
            primaryOwnerLabel={primaryOwnerLabel}
            primaryOwnerInfoMessage={primaryOwnerInfoMessage}
            primaryOwnerPlaceholder={primaryOwnerPlaceholder}
            />}
          {fetchingScheduleDefinition && <SpinLoader />}
      </span>
    </div>
  </>;

  return (
    <div className={styles.schedulePanel}>
      <div>
        <h3>
          <span>{schedule_title}</span>
        </h3>
        <hr />
        <div className="row">
          <div className="col-12">
            {scheduleDefinition?.failedToCreateTrigger && 
              <div className={`alert alert-error ${styles.hasDanger}`}>
                <p>{failed_to_create_trigger}</p>
              </div>}
            <span>
              {!scheduleDefinition && <div className={styles.buttonWrapper}>
                <ButtonSecondary classNames={`${styles.linkButton}`} onClick={onAddScheduleDefinition}>
                  <span>{add_schedule}</span>
                </ButtonSecondary>
              </div>}
            </span>
            {scheduleDefinitionDetails}
          </div>
        </div>
      </div>
    </div>
  );
}
